"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GatingStateKeys = void 0;
var GatingStateKeys;
(function (GatingStateKeys) {
    GatingStateKeys["BetaFeaturesEnabled"] = "BetaFeaturesEnabled";
})(GatingStateKeys || (exports.GatingStateKeys = GatingStateKeys = {}));
const initialState = {
    [GatingStateKeys.BetaFeaturesEnabled]: [],
};
class GatingStateController {
    state = initialState;
    keysInitialized = new Set();
    logger;
    constructor(logger) {
        this.logger = logger;
    }
    get(key) {
        if (!this.keysInitialized.has(key)) {
            this.logger.warn(`GatingStateController get called on key [${key}] before initialization. Ensure the gate value is correct`);
        }
        return this.state[key];
    }
    set(key, value) {
        this.keysInitialized.add(key);
        this.state[key] = value;
    }
}
exports.default = GatingStateController;
//# sourceMappingURL=GatingStateController.js.map